import { useCallback } from "react";
import { QueryFunction, useQuery } from "react-query";
import { AxiosError } from "axios";

import { fetchRollups } from "modules/projects/api/projects";

import { IRollups } from "modules/projects/types/entities";

export const ROLLUPS_QUERY_KEY = "/project_groups/rollup_list";

type RollupsQueryKey = [string, boolean];

export const useRollupsQuery = ({
  disableCache,
  includeArchived
}: { disableCache?: boolean; includeArchived?: boolean } = {}) => {
  const queryFn: QueryFunction<IRollups, RollupsQueryKey> =
    useCallback(async () => {
      return await fetchRollups(includeArchived);
    }, [includeArchived]);

  const results = useQuery<IRollups, AxiosError, IRollups, RollupsQueryKey>(
    [ROLLUPS_QUERY_KEY, Boolean(includeArchived)],
    queryFn,
    {
      staleTime: disableCache ? 0 : undefined,
      cacheTime: disableCache ? 0 : undefined
    }
  );

  return results;
};
